import React from 'react';
import { Icon } from '../../primitives';



type SearchIconProps = {
    searchOpen: boolean;
    setSearchOpen: (searchOpen: boolean) => void;
};

export default function SearchIcon(props: SearchIconProps) {
    const { searchOpen, setSearchOpen } = props;
    const searchIcon =
        'M10.14,0A7.044,7.044,0,0,0,4.707,11.532L0,16.239l.949.949,4.707-4.707A7.046,7.046,0,1,0,10.14,0Zm0,12.753a5.705,5.705,0,1,1,5.705-5.705A5.712,5.712,0,0,1,10.14,12.753Z';

    return (
        <div className='searchIcon' onClick={() => setSearchOpen(!searchOpen)}>
            <Icon
                d={searchIcon}
                size='18'
                viewBox='0 0 17.188 17.188'
                transform='translate(0 0)'
            />
        </div>
    );
}
